module.exports = __webpack_public_path__ + "img/user-default.01e6b2d9.png";